<template>

    <div class="header-section">
     
      <div class="content-section">
        
        <div class="content mb-5">
          <h3 class="section-title">{{ $t('smsSettings') }}</h3>
          <div class="grid grid-cols-1 gap-4">
            <div class="flex flex-col">
              <label class="text-sm mb-1">{{ $t('apiKey') }}</label>
              <input
                v-model="settings.settings.api_key"
                type="password"
                class="input-main"
                dir="ltr"
              />
            </div>
      
         
          </div>
        </div>

  

      </div>
    </div>

</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  created() {
    if (!this.settings.settings) {
      this.settings.settings = {};
    }
    
    const defaults = {
      api_key: '',
    };

    for (const [key, value] of Object.entries(defaults)) {
      if (this.settings.settings[key] === undefined) {
        this.settings.settings[key] = value;
      }
    }
  },

};
</script>